import React from 'react';

/**
 * Shared UI tokens for the customer portal — a small, reused scale so screens stop inventing
 * per-component spacing/radii. UX refinement only (no colour change): keep the white + orange brand.
 */

// Spacing scale (px). Prefer these over ad-hoc numbers.
export const space = { xs: 4, sm: 8, md: 12, lg: 16, xl: 20, xxl: 24 } as const;

// Radius scale. control = inputs/small buttons/icons; card = cards + big buttons; pill = fully round.
export const radius = { control: 12, card: 16, pill: 9999 } as const;

// Two elevation levels only.
export const shadow = {
  sm: '0 2px 8px rgba(15,23,42,0.05)',
  md: '0 10px 24px rgba(15,23,42,0.10)',
} as const;

// Brand accents (unchanged) — centralised so the same orange is reused, not re-typed.
export const brand = {
  orange: '#FF6B35',
  orangeDeep: '#e0531f',
  gradient: 'linear-gradient(135deg,#FF6B35,#FF8A5B)',
} as const;

/**
 * Global CSS injected once (via <UiStyles/>). Add className "ui-scope" to a screen's root container
 * and every button/[role=button]/label inside gets subtle tap-press feedback — no per-element churn.
 * Subtle by design (honours prefers-reduced-motion); over-animation reads as generic.
 */
export const UI_STYLES_CSS = `
.ui-scope button,.ui-scope [role="button"]{transition:transform .09s ease, box-shadow .14s ease, opacity .14s ease}
.ui-scope button:not(:disabled):active,.ui-scope [role="button"]:active{transform:scale(.975)}
.ui-scope button:disabled{opacity:.55}
@media(prefers-reduced-motion:reduce){.ui-scope button,.ui-scope [role="button"]{transition:none}.ui-scope button:active,.ui-scope [role="button"]:active{transform:none}}
`;

/** Mount once (near the root of a scoped screen) to enable the tap-press micro-interaction. */
export const UiStyles: React.FC = () => React.createElement('style', null, UI_STYLES_CSS);
